<template>

  <form @submit.prevent>
     <CModal
        :title.sync="title"
        color="info"
        size="lg"
        :closeOnBackdrop ="false"
        :show.sync="show">
        <strong > Personal Information </strong>
        <CRow>
          <CCol >
             <label class="mt-3"> Name </label>
             <CRow >
              <CCol >
              <b-input v-model="form.firstname" placeholder='First name' :class="errors.firstname ? 'is-invalid' : ''" id="feedback-user" class="mb-1"> </b-input>
              <b-form-invalid-feedback>
              Your firstname must be filled
              </b-form-invalid-feedback>
              </CCol>
              <CCol >
              <b-input v-model="form.lastname" placeholder='Last name' :class="errors.lastname ? 'is-invalid' : ''" id="feedback-user" class="mb-1"> </b-input>
              <b-form-invalid-feedback >
              Your lastname must be filled
              </b-form-invalid-feedback>
              </CCol>
            </CRow>
            <CRow>
              <CCol>
            <label class="mt-3"> Date of Birth </label>
              </CCol>
              <CCol>
                <label class="mt-3"> Gender </label>
              </CCol>
            </CRow>
           <CRow >
              <CCol >
                <b-input v-model="form.dob" label="Date Of Birth"  type="date"  > </b-input>
              </CCol>
              <CCol>
               <b-form-group :class="errors.gender ? 'is-invalid' : ''" >
                  <b-form-radio v-model="form.gender"  name="some-radios" value="male">Male</b-form-radio>
                  <b-form-radio v-model="form.gender" name="some-radios" value="female">Female</b-form-radio>
                </b-form-group>
              <b-form-invalid-feedback >
              Your Gender must be filled
              </b-form-invalid-feedback>
              </CCol>
           </CRow>
            <CRow >
              <CCol lg="6" >
                  <b-input v-model="form.email" label="Email" placeholder='Email' :class="errors.email ? 'is-invalid' : ''" id="feedback-user" ></b-input>
              <b-form-invalid-feedback >
              Example : testemail@yahoo.com
              </b-form-invalid-feedback>
              </CCol>

            </CRow>
            <label class="mt-2"> Phone </label>
             <CRow  >
              <CCol >
                <b-input v-model="form.phone" placeholder='Phone number' type="number" step="1" min="0" @keydown="filterKey" @input="filterInput" class="mb-1" > </b-input>
              </CCol>
              <CCol >
              <b-input v-model="form.mobile_phone" :class="errors.mobile_phone ? 'is-invalid' : ''" placeholder='Mobile Phone' type="number" step="1" min="0" @keydown="filterKey" @input="filterInput" id="feedback-user" class="mb-1">  </b-input>
              <b-form-invalid-feedback >
              Your mobile phone must be filled
              </b-form-invalid-feedback>
              </CCol>
            </CRow>
            <strong > Address Information </strong>
             <CRow>
              <CCol >
              <b-input v-model="form.address1" placeholder='Address 1' :class="errors.address1 ? 'is-invalid' : ''" id="feedback-user" class="mb-1"> </b-input>
              <b-form-invalid-feedback >
              Your address must be filled
              </b-form-invalid-feedback>
              </CCol>
           </CRow>
           <CRow class="mt-0"    >
              <CCol >
                <b-input v-model="form.city" placeholder='City' > </b-input>
              </CCol>
              <CCol >
                 <b-input v-model="form.state" placeholder='State/Province' class="mb-1" > </b-input>
              </CCol>
            </CRow>
            <CRow class="mt-2">
              <CCol>
                <b-input v-model="form.country"  placeholder='Country' > </b-input>
              </CCol>
              <CCol >
                 <b-input v-model="form.zipcode"  placeholder='ZipCode'  > </b-input>
              </CCol>
            </CRow>
            <CRow class="mt-2 mb-3" >
              <CCol >
                <b-input v-model="form.address2"  placeholder='Address 2' > </b-input>
              </CCol>
            </CRow>
            <strong > Service Information </strong>

             <CRow>

              <CCol >
                <label class="mt-2"> Service Date </label>
                <b-input v-model="form.service_date" type="date" :class="errors.service_date ? 'is-invalid' : ''" id="feedback-user"  > </b-input>
                <b-form-invalid-feedback >
              Your Service Date must be filled
              </b-form-invalid-feedback>
              </CCol>
              <CCol class="mt-2">
              <label>Service Type</label>
              <b-form-select
                v-model="form.service_type"
                :options= "options_service"
                :state="validationServicetype"
                id="feedback-user"
                :class="errors.service_type ? 'is-invalid' : ''"
               >
              </b-form-select>
              <b-form-invalid-feedback >
              Your service type must be filled
              </b-form-invalid-feedback>
              </CCol>
           </CRow>
          </CCol>

           </CRow>
            <strong >  Information for Church </strong>
              <CRow class="mt-3">
                <CCol lg="6"  >
                  <c-textarea v-model="form.permohonan_doa"
              label="Permohonan Doa"
              placeholder="Write your pray"
              rows="5"
            />
             <label> Status Kawin </label>
              <CRow>

                <CCol >
                <b-form-select v-model="form.marital_status" :options="options_kawin"></b-form-select>
                </CCol>
              </CRow>
              <label class="mt-2"> Jumlah Anak </label>
              <CRow>
                <CCol >
              <b-input class="mb-2" v-model="form.number_of_children" placeholder='Jumlah Anak'  > </b-input>
                </CCol>
              </CRow>

              </CCol>
              <CCol lg="6">
                <c-textarea v-model="form.why_christian" label="Christianity" rows="5" placeholder='Christianity' description="Deskripsikan seorang Kristen yang bagaimanakah Anda" />
              </CCol>
              <CCol lg="6">
                <label class="mt-3"> Tujuan </label>
                <b-form-select v-model="form.tujuan_id" :options="options_tujuan"></b-form-select>
                <!-- <label> Transfer dari IFGF </label>
            <b-input placeholder='Nama IFGF' description="Hanya diisi jika Anda transfer dari IFGF"  > </b-input> -->
              </CCol>
              <CCol lg="6">
                <label  class="mt-3"> Keperluan </label>
              <b-form-select v-model="form.keperluan_id" :options="options_keperluan"></b-form-select>
              <!-- <b-input  label="Keperluan Lain" placeholder='Nama IFGF'  > </b-input>  -->
              </CCol>
              </CRow>

              <b-form-checkbox
              class="mt-3"
              id="checkbox-1"
              v-model="form.is_subscribe"
              name="checkbox-1"
              value="1"
              unchecked-value="0"
            >
              Berikan tanda <b-icon icon="check" font-scale="1.5"> ></b-icon>  untuk mendapatkan informasi kegiatan setiap bulan.
            </b-form-checkbox>

          <template #footer>
        <CButton @click="show = false" color="danger">Cancel</CButton>
        <CButton  v-if="mode === 'create'" type="submit" v-on:click.prevent="create()"  variant="outline" color="info">Create</CButton>
        <CButton  v-if="mode === 'edit'" type="submit" v-on:click.prevent="update(form.uuid)"  variant="outline" color="info">Update</CButton>
      </template>
         <!-- <pre>{{ $data | json }}</pre> -->
    </CModal>

  </form>
</template>

<script>
import EventBus from '@/eventBus';

import newcomer from '@/services/newcomer';
import service from '@/services/service';
import keperluan from '@/services/keperluan';
import tujuan from '@/services/tujuan';

import moment from 'moment';

export default {
name: 'newcomermodal',

  data () {
    return {
      show: false,
      title: 'Default Title',
      mode: '',
      value:'',
      errors: {},
      errors_from_backend: [],
      form:{
        uuid:'',
        id:'',
        firstname:'',
        dob:'',
        lastname: '',
        gender:'',
        email:'',
        phone:'',
        mobile_phone: '',
        service_type:'',
        service_date:'',
        address1:'',
        address2:'',
        location:'',
        city:'',
        country:'',
        state:'',
        zipcode:'',
        marital_status:'',
        permohonan_doa:'',
        moment:'',
        keperluan_id:'',
        tujuan_id:'',
        why_christian:'',
        number_of_children:'',
        is_subscribe:''

      },
      options_service:[ ],
      options_tujuan:[],
      options_keperluan:[],
      options_kawin:[
          { text: 'Belum menikah ', value: '0' },
          { text: 'Sudah menikah', value: '1' },
          { text: 'Single parent', value: '2' },],

      largeModal:false,
      largeModal1:false,
      loading: false,
    }

  },

  computed: {
    },
  created () {
    var self = this;
      EventBus.$on('OPEN_MODAL_NEWCOMER', (params) => {
      if(params.data){
      newcomer.getNewComerbyID(params.data)
      .then(res => {
      self.show = true;
      self.title = params.title;
      self.mode = params.mode;
      self.form.uuid = params.data;
      self.form.firstname = res.data.firstname;
      self.form.lastname = res.data .lastname;
      self.form.dob = res.data.dob;
      self.form.email = res.data.email;
      self.form.gender = res.data.gender;
      self.form.address1 = res.data.address1;
      self.form.phone = res.data.phone;
      self.form.mobile_phone = res.data.mobile_phone;
      self.form.service_type = res.data.service_type;
      self.form.service_date = res.data.service_date;
      self.form.keperluan_id = res.data.keperluan_id;
      self.form.tujuan_id = res.data.tujuan_id;
      self.form.location = res.data.location;
      self.form.address2 = res.data.address2;
      self.form.why_christian = res.data.why_christian;
      self.form.number_of_children = res.data.number_of_children;
      self.form.city = res.data.city;
      self.form.is_subscribe = res.data.is_subscribe;
      self.form.marital_status = res.data.marital_status;
      self.form.country = res.data.country;
      self.form.zipcode = res.data.zipcode;
      self.form.state = res.data.state;
      self.form.permohonan_doa = res.data.permohonan_doa;
      }).catch ((err) => {
        var params = {title: 'Error', mode:'danger', data:err.response.data.message}
        EventBus.$emit('OPEN_MODAL_ALERT', params)
        })

      }else{
        self.show = true;
        self.title = params.title;
        self.mode = params.mode;
        self.form.id = "";
        self.form.uuid = "";
        self.form.firstname = "";
        self.form.lastname = "";
        self.form.dob = "";
        self.form.gender = "";
        self.form.email = "" ;
        self.form.address1 = "" ;
        self.form.address2 = "" ;
        self.form.phone = "";
        self.form.mobile_phone = "" ;
        self.form.service_type = "";
        self.form.service_date = "";
        self.form.marital_status = "0";
        self.form.number_of_children = "";
        self.form.is_subscribe = "0";
        self.form.country = "";
        self.form.location = "" ;
        self.form.city = "";
        self.form.state = "";
        self.form.zipcode = "";
        self.form.state = "";
        self.form.why_christian = "";
        self.form.permohonan_doa = "";
        self.form.keperluan_id = "";
        self.form.tujuan_id = "";
      }
    });
     service.getService()
      .then(res => {
        for (let i=0; i <= res.data.length; i++){
          //alert
          this.options_service.push({text: res.data[i].name, value:res.data[i].name})
        }
      }).catch((er) =>{
      })
      tujuan.getTujuan()
      .then(res => {
        for (let i=0; i <= res.data.length; i++){
          //alert
          this.options_tujuan.push({text: res.data[i].name, value:res.data[i].id})
        }
      }).catch((er) =>{
      })
      keperluan.getKeperluan()
      .then(res => {
        for (let i=0; i <= res.data.length; i++){
          //alert
          this.options_keperluan.push({text: res.data[i].name, value:res.data[i].id})
        }
      }).catch((er) =>{
      })
      this.options_keperluan.push({text: res.data[i].name, value:res.data[i].id})
  },
  methods: {
    open () {
      this.show = true;
    },
    close () {
      this.show = false;
    },
    create(){
      this.loading = true;
      // this.form.dob  = moment(this.form.dob).format ('DD/MM/YYYY')
      this.form.service_date =moment(this.form.service_date).format ('DD/MM/YYYY') ;
      if(  this.form.dob != null ){
        this.form.dob =  moment(this.form.dob).format ('DD/MM/YYYY') ;
      }
      else{
          this.form.dob   = ''
      }
      if (this.check_form()) {
      newcomer.createNewComer(this.form)
      .then(res => {
        EventBus.$emit('TABLE_UPDATE', true)
        var params = {title: 'Success', mode:'success', data:res.message}
        EventBus.$emit('OPEN_MODAL_ALERT', params)
        this.show = false;
        }).catch((err) => {
        this.loading = false;
        alert(err.response.data.message);
        //alert(JSON.stringify(err.response.data.errors));
        if (err.response.data.errors != null) {
            this.errors_from_backend = err.response.data.errors;
            console.log(JSON.stringify(err.response.data.errors));
        }
          });
      }else{
      this.loading = false;
      }

    },
    filterKey(e){
      const key = e.key;

      // If is '.' key, stop it
      if (key === '.')
        return e.preventDefault();

      // OPTIONAL
      // If is 'e' key, stop it
      if (key === 'e')
        return e.preventDefault();
    },

    // This can also prevent copy + paste invalid character
    filterInput(e){
      e.target.value = e.target.value.replace(/[^0-9]+/g, '');
    },
    update(id){
      this.show = false;
      this.form.service_date = moment(this.form.service_date).format ('DD/MM/YYYY') ;
      if(  this.form.dob != null ){
         this.form.dob =  moment(this.form.dob).format ('DD/MM/YYYY') ;
      }
      else{
          this.form.dob   = ''
      }

      newcomer.updateNewComer(id, this.form)
      .then(res => {
        EventBus.$emit('TABLE_UPDATE', true)
        var params = {title: 'Success', mode:'success', data:res.message}
        EventBus.$emit('OPEN_MODAL_ALERT', params)
      }).catch ((err) => {
        var params = {title: 'Error', mode:'danger', data:err.response.data.message}
        EventBus.$emit('OPEN_MODAL_ALERT', params)
      })
    },
    check_form: function(e) {
         this.errors = {};
         if (!this.form.firstname) {
            this.errors["firstname"] = "1";
         }
         if (!this.form.lastname) {
            this.errors["lastname"] = "1";
         }
         if (!this.form.email) {
            this.errors["email"] = "1";
         }
         if (!this.form.gender) {
            this.errors["gender"] = "1";
         }
         if (!this.form.mobile_phone) {
            this.errors["mobile_phone"] = "1";
         }
         if (!this.form.address1) {
            this.errors["address1"] = "1";
         }
         if (!this.form.service_date) {
            this.errors["service_date"] = "1";
         }
         if (!this.form.service_type) {
            this.errors["service_type"] = "1";
         }

         if (
            this.form.firstname &&
            this.form.lastname &&
            this.form.email &&
            this.form.gender &&
            this.form.mobile_phone &&
            this.form.address1 &&
            this.form.service_date &&
            this.form.service_type
         ) {
            return true;
         } else {
            return false;
         }
      },

  }
}
</script>

<style>

</style>